import Services from '../../services'

const state = {
  modals: {},
  modalsId: [],
  dashboard: [],
  dashboardIsLoaded: false,
};

// getters
const getters = {
  getModal: (state, getters, rState, rGetters) => id => {
    return state.modals[id];
  },
  dashboard: (state, getters) => {
    return state.dashboard;
  },
  dashboardIsLoaded: (state, getters) => state.dashboardIsLoaded,
};

// actions
const actions = {
  createModal({commit, state, dispatch}, id) {
    commit('createModal', id);
  },
  async fetchDashboard({commit, state, dispatch}) {
    dispatch('wait/start', 'ui.fetchDashboard', { root: true });
    const data = await Services.Ui.fetchDashboard(1);
    commit('updateDashboard', data);
    commit('updateDashboardStatus', true);
    dispatch('wait/end', 'ui.fetchDashboard', { root: true });
  },
  updateDashboard({commit, state, dispatch}, newDashboard) {
    commit('updateDashboard', newDashboard);
  },
  addToDashboard({commit, state, dispatch}, panel) {
    if(!state.dashboard.find(c => panel.id === c.id)) {
      panel.position = state.dashboard.length + 1;
      commit('addToDashboard', panel);
    }
  }
};

// mutations
const mutations = {
  createModal(state, id) {
    state.modals[id] = {
      id,
    };

    state.modalsId.push(id);
  },
  updateModal(state, {id}) {
    state.modals[id] = {
      ...state.modals[id].data,
    }
  },
  updateDashboard(state, dashboard) {
    state.dashboard = dashboard;
  },
  updateDashboardStatus(state, status) {
    state.dashboardIsLoaded = status;
  },
  addToDashboard(state, panel) {
    state.dashboard.push(panel);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/ui.js